module.exports = __webpack_public_path__ + "static/media/zgoda_wywiad_stomatologiczny.4eac14f4.pdf";